// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__fB1w-","mobile":"style_mobile__mqo1j","laptop":"style_laptop__dzNAA","v3":"style_v3__tKTnH"};